// extracted by mini-css-extract-plugin
export default {"tableContainer":"UnplannedAbsence__tableContainer___RamsP"};